$(document).ready(function(){ 
  $(".bar-title-main").click(function(){
     //$(".hide-timere").toggleClass('show-div');
     $('.hide-timere').slideToggle();
     //$('.bar-title-main').addClass("fadeout");
      if ($('.bar-title-main').hasClass("fadeout"))
         $('.bar-title-main').removeClass("fadeout");
    else
        $('.bar-title-main').addClass("fadeout");
  });   
}); 